import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=702f8f87&"
import script from "./message-list.js?vue&type=script&lang=js&"
export * from "./message-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports